import React, {useState, useEffect, useContext, Fragment} from 'react'
import {Context} from '../../components/Store'
import {useMutation} from '@apollo/client'
import {Grid, Toolbar, makeStyles, IconButton, Chip, Fab, Badge} from '@material-ui/core'
import RichInput from '../../components/RichInput'
import {FaCheck, FaCheckCircle, FaPlusCircle, FaTimesCircle} from 'react-icons/fa'
import { Alert } from '@material-ui/lab'
import Confirm from '../../components/Confirm'
import {CLASIF_MUTATION, CLASIF_REMOVE_MUTATION} from '../../apollo/mutation'

  
const useStyles = makeStyles(theme=>({
    toolbar: {
        background: theme.palette.grey[200], fontWeight: 800, marginBottom: theme.spacing(2),
        display: "flex", justifyContent: "space-between",
        paddingRight: theme.spacing(0.5)
    },
    container: {padding: theme.spacing(1), border: "1px solid grey", maxHeight: "60vh", overflowY: "scroll"}
}))

export default function Clasificatie(props) {

    const classes = useStyles()
    const [state, setState] = useContext(Context)
    const [clasificatie, setClasificatie] = useState()
    const [currentIndex, setCurrentIndex] = useState()
    const [indexes, setIndexes] = useState([])
    const [confirm, setConfirm] = useState(false)
    const [removeClasif, dispRemove] = useMutation(CLASIF_REMOVE_MUTATION)
    const [submitClasif, dispSubmit] = useMutation(CLASIF_MUTATION)

    useEffect(() => {
        if ( props && props.clasificatie ) { setClasificatie(props.clasificatie)}
    }, [props])

    const inputHandler = (name, i) => ev => {
        let newClasif = [...clasificatie].map( el => ({...el}))
        newClasif[i][name] = ev.target.value
        setClasificatie(newClasif)
        setCurrentIndex(i)
        if ( !indexes.includes(i)){ setIndexes([...indexes, i])}
    }

    const createItemHandler = () => {
        let newItem = {id: null, company_id: state.company_id, name: "", desc: ""}
        let newClasif = [...clasificatie]
        newClasif.push(newItem)
        setIndexes([...indexes, clasificatie.length])
        setClasificatie(newClasif)
    }

    const submitHandler = (e,i) => () => {
        let elem = {
            id: e.id,
            company_id: state.current_company_id,
            name: e.name,
            ordering: e.ordering,
            props: e.props
        }
        submitClasif({variables: { data: elem }})
            .then( 
                r => {
                    let ix = [...indexes]
                    ix.splice(i,1)
                    setIndexes(ix)
                    props.onSubmit(true)
                },
                err => console.log("clasif create error:", err)
            )
    }

    const removeOpenConfirmHandler = (e,i) => () => {
        setCurrentIndex(i)
        setConfirm(true)
    }

    const removeHandler = ev => {
        if (ev){

         if (clasificatie[currentIndex]['id']) {
             removeClasif({variables: {id: clasificatie[currentIndex]['id']}})
                .then(r => props.onSubmit(true), err => console.log("remove err:", err))
         } else {
             let newClasif = [...clasificatie]
             newClasif.splice(currentIndex, 1)
             setClasificatie(newClasif)
         }
            
        }
        setCurrentIndex();setConfirm()
    }

    return (
        <div>
            <Toolbar variant = "dense" className = {classes.toolbar}>
                ADMINISTRARE CLASIFICAȚIE
                <div align = "right">
                    <IconButton size = "medium" color = "primary" onClick = {createItemHandler}>
                        <FaPlusCircle/>
                    </IconButton>
                </div>
            </Toolbar>
            <div className = {classes.container}>
               
                <Grid container  spacing = {1}>
                    {clasificatie && clasificatie.map( (e,i) => (
                        <Grid item xs = {6} key = {i}>
                            <RichInput 
                                value = {e.name} 
                                onChange = {inputHandler('name', i)}
                                start = {<div>{i+1}. &nbsp;</div>}
                                end = {
                                    <Grid >
                                        <IconButton size = "small" color = "secondary" onClick = {removeOpenConfirmHandler(e,i)}>
                                            <FaTimesCircle/>
                                        </IconButton> &nbsp;
                                        <IconButton
                                            onClick = {submitHandler(e,i)} 
                                            size = "small" color = "primary" disabled = {!indexes.includes(i)}
                                        >
                                            <FaCheckCircle/>
                                        </IconButton>
                                    </Grid>
                                }
                            />
                        </Grid>
                    ))}
                     
                </Grid>
            </div>
            {/* {clasificatie && <pre>{JSON.stringify(clasificatie, null, 4)}</pre>} */}
            <Confirm open = {confirm} onClose = {removeHandler} />
        </div>
    )
}
